// extracted by mini-css-extract-plugin
export default {"backCoverAuthorImg":"BackCovers_backCoverAuthorImg__8g9cl"};